export default __webpack_public_path__ + "static/media/launchkit.a56adc5b.svg";